import { createAction } from '@reduxjs/toolkit';

import { ShowToastPayload } from 'models/app/toast';

import {
    INIT_APPLICATION,
    APPLICATION_READY_AUTHORISED_USER, APPLICATION_READY_AUTHORISED_USER_NEW_CONSENT, APPLICATION_READY_UNAUTHORISED_USER,
    GET_JWT_TOKEN_FORM_STORAGE, REMOVE_JWT_TOKEN_FROM_STORAGE,
    HIDE_AUTO_LOGOUT_BANNER, SHOW_AUTO_LOGOUT_BANNER,
    SET_CLIPBOARD_CONTENT,
    SET_QUERY_PARAMS,
    SET_SESSION_UUID,
    SHOW_TOAST,
} from './action.types';

export const initApplication = createAction(INIT_APPLICATION);

export const applicationReadyUnauthorisedUser = createAction(APPLICATION_READY_UNAUTHORISED_USER);
export const applicationReadyAuthorisedUserNewConsent = createAction(APPLICATION_READY_AUTHORISED_USER_NEW_CONSENT);
export const applicationReadyAuthorisedUser = createAction(APPLICATION_READY_AUTHORISED_USER);

export const setSessionUuid = createAction(SET_SESSION_UUID, (sessionUuid: string) => {
    return { payload: sessionUuid };
});
export const getJwtTokenFormStorage = createAction(GET_JWT_TOKEN_FORM_STORAGE, (originalSessionUuid?: string) => {
    return { payload: originalSessionUuid };
});
export const removeJwtTokenFromStorage = createAction(REMOVE_JWT_TOKEN_FROM_STORAGE);

export const showAutoLogoutBanner = createAction(SHOW_AUTO_LOGOUT_BANNER);
export const hideAutoLogoutBanner = createAction(HIDE_AUTO_LOGOUT_BANNER);

export const setClipboardContent = createAction(SET_CLIPBOARD_CONTENT, (text) => {
    return { payload: text };
});


export const showToast = createAction(SHOW_TOAST, ({ type, message, description, options, id }: ShowToastPayload) => {
    return {
        payload: {
            type,
            message,
            description,
            options,
            id,
        },
    };
});


export const setQueryParams = createAction(SET_QUERY_PARAMS, ({ reducerName, fieldName, queryParams, locationPathname }) => {
    return {
        payload: {
            reducerName,
            fieldName,
            queryParams,
            locationPathname,
        },
    };
});

export default {
    initApplication,
    applicationReadyUnauthorisedUser,
    applicationReadyAuthorisedUser,
    setSessionUuid,
    getJwtTokenFormStorage,
    removeJwtTokenFromStorage,
    showAutoLogoutBanner,
    hideAutoLogoutBanner,
    setClipboardContent,
    setQueryParams,
    showToast,
};
